export const MAIN_CLASS_NAME = 'ib-text-collapse';
export const SWITCH_BUTTON_CLASS_NAME = `${MAIN_CLASS_NAME}__switch-button`;
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const CONTENT_TEXT_CLASS_NAME = `${CONTENT_CLASS_NAME}__text`;

export const COLLAPSED_HEIGHT = '20px'; // NOTE: same as @ib-line-height-base
export const MAX_HEIGHT_PROPERTY = 'max-height';
